import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { HashLoader } from "react-spinners";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import { COLORS } from "../../utils/colors";
import { MainButton } from "../../components/MainButton";
import { updateEvent } from "../../api/events";
import { ICONS } from "../../utils/icons";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 250,
      minWidth: 250,
      fontFamily: "AuthenticSans90",
    },
  },
};

export const CreateQuestionDialog = ({
  openPopup,
  setOpenPopup,
  questions,
  handleSnackbar,
  event,
  setEvent,
}) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const formik = useFormik({
    initialValues: {
      title: "",
      question_type: "",
      required: false,
    },
    validationSchema: yup.object({
      title: yup.string("Enter title").required("Required"),
      question_type: yup.string("Enter type").required("Required"),
    }),
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleClose = () => {
    setOpenPopup(false);
  };

  const addOption = async () => {
    if (options[options.length - 1] === "")
      return handleSnackbar("Please fill in the previous option", "error");
    setOptions([...options, ""]);
  };

  const deleteOption = async (givenIndex) => {
    const newOptions = options.filter((item, index) => index !== givenIndex);
    setOptions(newOptions);
  };

  const handleTextFieldChange = (index, event) => {
    const newValues = [...options];
    newValues[index] = event.target.value;
    setOptions(newValues);
  };

  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);

      const confirmAction = window.confirm(
        "Are you sure you want to take this action?"
      );

      if (!confirmAction) {
        setLoading(false);
        return;
      }

      let updates = {};
      updates["form_questions"] = questions || [];
      let updateData = {
        ...values,
        options: options,
      };
      updates.form_questions.push(updateData);

      const { data, error } = await updateEvent(updates, event);

      if (data) {
        setEvent(data);
      }

      if (error) {
        handleSnackbar(error, "error");
        setLoading(false);
        return;
      }

      handleSnackbar("Ticket discount updated successfully", "success");
      handleClose();
      setLoading(false);
    } catch (error) {
      console.log("error: ", error);
      handleSnackbar(error, "error");
      setLoading(false);
    }
  };

  return (
    <Dialog open={openPopup} onClose={() => handleClose()}>
      <DialogContent
        sx={{
          width: "500px",
          padding: "40px",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <form style={{ width: "500px" }}>
          <h2 style={{ width: "-webkit-fill-available", marginBottom: "20px" }}>
            {ICONS.plusBlack25} Create new question
          </h2>

          <FormGroup style={{ marginBottom: "20px" }}>
            <FormControlLabel
              sx={{
                "& .MuiTypography-root": {
                  fontFamily: "AuthenticSans90",
                },
              }}
              control={
                <Checkbox
                  name={"required"}
                  checked={formik.values.required}
                  onChange={formik.handleChange}
                />
              }
              label="Required Question"
            />
            <p style={{ fontSize: "14px", color: "grey" }}>
              Mark this question as required
            </p>
          </FormGroup>
          <div className="field-container">
            <p
              // id="subheader"
              style={{
                margin: "0px 0px 3px",
                alignSelf: "center",
              }}
            >
              Title*
            </p>
            <TextField
              fullWidth
              disabled={loading}
              size="small"
              className="input"
              name="title"
              placeholder="not set"
              value={formik.values.title}
              onChange={formik.handleChange}
              error={formik.touched.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
              sx={{
                "& label": {
                  paddingLeft: (theme) => theme.spacing(1),
                },
                "& fieldset": {
                  borderRadius: "6px",
                  border: `2px solid #f0f1f5`,
                  transition: ".2s ease-in-out all",
                },
                "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#f0f1f5",
                  },
                "& .MuiOutlinedInput-input:hover": {
                  cursor: loading && "not-allowed",
                },
              }}
            />
          </div>
          <div className="field-container">
            <p
              // id="subheader"
              style={{
                margin: "0px 0px 3px",
                alignSelf: "center",
              }}
            >
              Type*
            </p>
            <Select
              size="small"
              name="question_type"
              value={formik.values.question_type}
              onChange={formik.handleChange}
              input={<OutlinedInput label="Name" />}
              MenuProps={MenuProps}
              style={{
                maxWidth: "100px",
                minWidth: "-webkit-fill-available",
                margin: "5  px 0",
              }}
              error={
                formik.touched.question_type &&
                Boolean(formik.errors.question_type)
              }
              sx={{
                "& label": {
                  paddingLeft: (theme) => theme.spacing(1),
                },
                "& fieldset": {
                  borderRadius: "6px",
                  border: `2px solid #f0f1f5`,
                  transition: ".2s ease-in-out all",
                },
                "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#f0f1f5",
                  },
                "& .MuiOutlinedInput-input:hover": {
                  cursor: loading && "not-allowed",
                },
              }}
            >
              <MenuItem value={"free"}>Free Form</MenuItem>
              <MenuItem value={"single"}>Single Select</MenuItem>
              <MenuItem value={"multiple"}>Multiple Select</MenuItem>
            </Select>
            <p
              id="subheader"
              style={{
                margin: "0px 0px 3px",
                alignSelf: "center",
              }}
            >
              {formik.values.question_type === "" && "Select a question type"}
              {formik.values.question_type === "free" &&
                "Free form questions allow answers in text from the user"}
              {formik.values.question_type === "single" &&
                "Single select questions allow one single answer to be selected from a list of predefined options"}
              {formik.values.question_type === "multiple" &&
                "Multiple select questions allow multiple answers to be selected from a list of predefined options"}
            </p>
          </div>
          {(formik.values.question_type === "single" ||
            formik.values.question_type === "multiple") && (
            <div className="field-container">
              <p
                style={{
                  margin: "0px 0px 3px",
                  alignSelf: "center",
                }}
              >
                Answer Options
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  flexDirection: "column",
                }}
              >
                {options?.map((value, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        fullWidth
                        disabled={loading}
                        size="small"
                        placeholder="not set"
                        value={value}
                        onChange={(event) =>
                          handleTextFieldChange(index, event)
                        }
                        error={
                          formik.touched.max_usage &&
                          Boolean(formik.errors.max_usage)
                        }
                        helperText={
                          formik.touched.max_usage && formik.errors.max_usage
                        }
                        sx={{
                          "& label": {
                            paddingLeft: (theme) => theme.spacing(1),
                          },
                          "& fieldset": {
                            borderRadius: "6px",
                            border: `2px solid #f0f1f5`,
                            transition: ".2s ease-in-out all",
                          },
                          "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "#f0f1f5",
                            },
                          "& .MuiOutlinedInput-input:hover": {
                            cursor: loading && "not-allowed",
                          },
                        }}
                      />
                      <MainButton
                        disabled={loading}
                        color={COLORS.white}
                        textColor={COLORS.black}
                        shadowColor={"transparent"}
                        hoverColor={COLORS.veryLightGrey}
                        textAlignment={"center"}
                        onClickAction={() => deleteOption(index)}
                        width={"fit-content"}
                      >
                        {ICONS.trashBlack20}
                      </MainButton>
                    </div>
                  );
                })}
              </div>
              <p
                id="subheader"
                style={{
                  margin: "0px 0px 3px",
                  alignSelf: "center",
                }}
              >
                Add predefined answer options for the user to select from
              </p>
            </div>
          )}

          <DialogActions sx={{ justifyContent: "space-between", padding: 0 }}>
            {(formik.values.question_type === "single" ||
              formik.values.question_type === "multiple") && (
              <MainButton
                disabled={loading}
                color={COLORS.white}
                textColor={COLORS.black}
                shadowColor={COLORS.black}
                borderColor={COLORS.black}
                textAlignment={"center"}
                onClickAction={() => addOption()}
                width={"fit-content"}
              >
                {loading ? (
                  <>
                    <HashLoader size={20} color={COLORS.grey} /> Add Option
                  </>
                ) : (
                  "Add Option"
                )}
              </MainButton>
            )}
            <MainButton
              disabled={loading}
              color={COLORS.black}
              shadowColor={"transparent"}
              textColor={COLORS.white}
              textHoverColor={COLORS.lightGrey}
              hoverColor={COLORS.black}
              textAlignment={"center"}
              onClickAction={() => formik.handleSubmit()}
              width={"fit-content"}
            >
              {loading ? (
                <>
                  <HashLoader size={20} color={COLORS.grey} /> Save
                </>
              ) : (
                "Save"
              )}
            </MainButton>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};
